// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/BackwardOutlined";
import AntdIcon from '../components/AntdIcon';

var BackwardOutlined = function BackwardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BackwardOutlinedSvg
  }));
};

BackwardOutlined.displayName = 'BackwardOutlined';
export default React.forwardRef(BackwardOutlined);